<template>
	<div>
		<HerderHead :banner="2" :pageindex="2" ref="logding"></HerderHead>

		<RitMenlian></RitMenlian>


		<div class="index_warp">
			 
			<div class="w">

				<div class="warp_items">




					<div class="group cle">

						<div class="item fl" v-for="(item,index) in data_list">
							<a href="###" @click="item.state == 0 ? msg()  : go(item.name)">
								<div class="img cm_box_img_item">
									<a href="#">
										<img :src="item.pic" v-if="item.pic" class="show_img" />
										<img src="../../static/p41.png" class="dianzi" />

									</a>
								</div>
								<div class="dm ">
									<div class="nt twotxtov">
										{{item.keywords}}
									</div>
									<div class="info txtov">

										Store: <span>{{item.store}}</span>

									</div>
									<div class="info txtov">

										Product id： <span>{{item.productId}}</span>

									</div>

									<!-- 无折扣价 -->
									<div class="price cle txtov" v-if="item.discountPrice == 0 ? true  : false">
															
										<span class="i1 fl">
											{{stationShortWord == '美国' ? '$' : stationShortWord == '德国' ? '€' : stationShortWord == '日本' ? '¥' : '' }}{{item.price}} 
										</span>
										<span class="i2 fl">
											  Free
										</span>
										<img src="../../static/p36.png" class="fl icon"
											v-if="item.tag == 'new' ? true : false" />
										<span class="i3 fr" v-if="item.stock == null ? false : true">
											 {{item.stock}}
										</span>
									</div>
									<!-- 有折扣价 -->
									<div class="price cle txtov" v-else>
										<span class="i1 fl">
											{{stationShortWord == '美国' ? '$' : stationShortWord == '德国' ? '€' : stationShortWord == '日本' ? '¥' : '' }}{{item.price}}
										</span>
										<span class="i2 fl">
											{{stationShortWord == '美国' ? '$' : stationShortWord == '德国' ? '€' : stationShortWord == '日本' ? '¥' : '' }}{{item.discountPrice}}
										</span>
										<img src="../../static/p36.png" class="fl icon"
											v-if="item.tag == 'new' ? true : false" />
										<span class="i3 fr">
											  {{item.stock}}
										</span>
									</div>



								</div>
							</a>
							<!-- 显示 -->
							<!-- <div class="show_boxs cle">

								<div class="sh_img ">
									<a href="#">
										<img :src="item.pic"  />
										 
										
									</a>
								</div>
								<div class="sh_cont ">
									<a href="#">
										<div class="sh_tit twotxtov">
											{{item.brandName}}
										</div>
										<div class="sh_info">
											Store: {{item.store}}<br>Product id：{{item.productId}}
										</div>
										<div class="sh_price cle">
											<span class="i1 fl">
												${{item.price}}
											</span>
											<span class="i2 fl">
												${{item.discountPrice}}
											</span>
										</div>
										<div class="sh_skoc">
											Hits: {{item.stock}}
										</div>
									</a>
								</div>

							</div> -->
						</div>

					</div>


					<div class="page_1">
						<a href="#" @click="clickPrev">
							< </a>
								<a href="#" v-for="(item,index) in page_info" :class="page_nub == index +1 ? 'on' : ''"
									@click="pagesdata(index+1)">
									{{index +1}}
								</a>

								<a href="#" @click="clickNext">
									>
								</a>

					</div>

				</div>


			</div>
		</div>
		<Footer></Footer>
	</div>
</template>



<script>
	//import HelloWorld from '../components/HelloWorld.vue'
	import HerderHead from "../components/header.vue"
	import Footer from "../components/footer.vue"
	import RitMenlian from "../components/rit.vue"

	export default {

		components: {

			HerderHead,
			Footer,
			RitMenlian
		},

		data() {
			return {
				data: '',
				hei: null,
				page_size: 36,
				page_nub: 1,
				status: "",
				stationShortWord: '',
				data_list: [], //页面数据
				page_info: null, //数据页面信息
			}
		},
		methods: {

			getProudctList() {
				var that = this;
				// pageNum：页数  
				// pageSize：每页数量
				// keywords：搜索关键词默认为空
				// status：all默认所有状态的
				// stationShortWord=归属国家
				// var data = {
				// 	pageNum: that.page_nub,
				// 	pageSize: that.page_nub,
				// 	keywords: '',
				// 	status: that.status,
				// 	stationShortWord: that.stationShortWord
				// }
				//window.localStorage.clear()
			 

				this.$axios({
					method: 'GET',

					url: 'gds/query?pageSize=' + that.page_size + '&pageNum=' + that.page_nub + '&status=' + that
						.status + '&stationShortWord=' + that.stationShortWord,
					// headers: {
					//   'Content-Type': 'application/json',//设置请求头请求格式为JSON

					// },
					// data:data,
					params: {}
				}).then((response) => {
					that.data_list = response.data.data.list;
					that.page_info = response.data.data.totalPage;
				}).catch(function(error) {});

				// this.$axios.post('gds/query', data)
				// 	.then(function(response) {

				// 		that.data_list = response.data.data.list;
				// 		that.page_info = response.data.data;

				// 	})
				// 	.catch(function(error) {});
			},
			goBack(e) {
				// console.log('执行这里的方法')
				//  console.log(e);
				//选择国家执行
				this.stationShortWord = e.station;
				console.log('这里是国家');
				console.log(this.stationShortWord);
				this.getProudctList();
			},
			getCouname(e) {
				//默认执行
				this.stationShortWord = e.station;
				console.log('12141');
				// console.log(e);
				console.log(this.stationShortWord);
				
				this.status = window.localStorage.getItem("product_start") || null;
				
				console.log('-------------');
				this.getProudctList();
			},
			//分页
			pagesdata(e) {
				this.page_nub = e;
				this.getProudctList();
				this.$refs.logding.opensloding();
				// that.logding = true;
				// setTimeout(function(){
				// 	that.logding = false;
				// },1000)
			},
			clickPrev() {
				var that = this;
				// this.page_info.totalPage;
				// this.page_nub = e;
				if (this.page_nub == 1) {
					console.log('已经是第一页')
				} else {
					this.page_nub--;
					this.getProudctList();
					this.$refs.logding.opensloding();
				}
			},
			clickNext() {
				var that = this;
				// this.page_info.totalPage;
				// this.page_nub = e;
				//that.$parent.getCouname
				console.log(this.page_nub);
				console.log(this.page_info);
				if (that.page_nub >= that.page_info) {
					console.log('已经是最后一页')
				} else {
					that.page_nub++;
					that.getProudctList();
					this.$refs.logding.opensloding();
				}
			},
			go(e) {
				//window.location.href = e;
				
				window.open(e);
			},
			msg(){
				alert(' Ooops！Sold Out!')
			}

		},
		mounted() {

		},
		created() {
			var that = this;
			console.log(window.localStorage.getItem("product_start"));
			//创建页面执行方法
			//console.log(this.data);
			//console.log('11222');
			//console.log(that.stationShortWord.station);

		},
		watch: {

		}
	}
</script>

<style>
	.index_warp {
		background: #F2F2F2;
		padding: 27px 0;
	}

	.index_warp .warp_items {
		margin-bottom: 40px;
	}

	.index_warp .ntnt {
		margin-bottom: 27px;
		font-size: 30px;

		color: #4B4B4B;
		font-weight: bold;
	}

	.index_warp .ntnt a {
		font-weight: normal;
		font-size: 17px;
		color: #5188A6;
		padding: 5px 0;
		padding-right: 25px;
		
		background: url(../../static/p33.png) right center no-repeat;
		background-size: 20px auto !important;
		/* background-size: 33px; */
	}

	.index_warp .group .item {
		background: #fff;
		width: 15%;
		margin-right: 1%;
		margin-bottom: 15px;
		position: relative;

	}

	.index_warp .group .item a {
		display: block;

	}

	.index_warp .group .item:hover {
		box-shadow: 0px 2px 3px rgba(181, 181, 181, 0.5);
		;
	}

	.index_warp .group .item:nth-child(6n) {
		margin-right: 0px;
	}

	.index_warp .group .item .dm {
		border: 0px none !important;
		border-top: 0px none;
		padding: 15px;
	}

	.index_warp .group .item .dm .nt {
		font-size: 16px;
		color: #1F1F1F;
		height: 24px;
	}

	.index_warp .group .item .dm .info {
		font-size: 12px;
		color: #4B4B4B;
		margin-bottom: 5px;
	}

	.index_warp .group .item .dm .info span {
		color: #B0B0B0;
	}

	.index_warp .group .item .dm .price {

		font-weight: bold;
		font-size: 16px;

	}

	.index_warp .group .item .dm .price .i1 {
		color: #C3C3C3;
		text-decoration: line-through;
		margin-top: 4px;
		margin-right: 5px;
	}

	.index_warp .group .item .dm .price .i2 {
		color: #FF6A00;
		font-size: 19px;
	}

	.index_warp .group .item .dm .price .icon {
		margin-left: 4px;
		position: absolute;
		left: 0px;
		top: 0px;
		z-index: 11;
		margin-top: 4px;
	}

	.index_warp .group .item .dm .price .i3 {
		font-size: 12px;
		color: #8A8A8A;
		margin-top: 6px;
		background: url(../../static/p43.png) left 0px no-repeat;
		background-size: 15px;
		padding-left: 20px;
	}


	.index_warp .group .item .show_boxs {
		position: absolute;
		left: 0;
		width: 700px;
		top: 50%;
		transform: translate(0, -50%);
		background: #FEFEFE;
		box-shadow: 0px 0px 15px 0px rgba(4, 0, 0, 0.36);
		border-radius: 6px 6px 3px 6px;
		padding: 15px;

		align-items: center;
		display: none;
		z-index: 999;

	}

	.index_warp .group .item:nth-child(6n) .show_boxs {
		left: -150%;
	}

	.index_warp .group .item:hover .show_boxs {
		display: flex;
	}

	.index_warp .group .item .sh_cont {
		padding-left: 20px;

	}

	.index_warp .group .item .show_boxs .sh_img,
	.index_warp .group .item .show_boxs .sh_img img {

		width: 330px;
		height: 330px;
	}

	.index_warp .group .item .show_boxs .sh_img {
		padding-right: 20px;
	}

	.index_warp .group .item .show_boxs .sh_img {
		border-right: 1px solid #EEEEEE;
	}

	.index_warp .group .item .sh_cont .sh_tit {
		font-size: 25px;
		color: #1F1F1F;
		font-weight: bold;
	}

	.index_warp .group .item .sh_cont .sh_info {
		font-size: 19px;
		color: #B0B0B0;
		line-height: 30px;
	}

	.index_warp .group .item .sh_cont .sh_price .i1 {
		color: #C3C3C3;

		font-size: 25px;
		font-weight: bold;
		margin-right: 10px;
		margin-top: 5px;
	}

	.index_warp .group .item .sh_cont .sh_price .i2 {
		color: #FF6A00;
		font-weight: bold;
		font-size: 30px;
	}

	.index_warp .group .item .sh_cont .sh_skoc {
		position: absolute;
		bottom: 10px;
		color: #8A8A8A;
		font-size: 18px;
	}

	.weizhi {
		margin-bottom: 40px;
	}

	.weizhi a {
		color: #898989;
		font-size: 16px;
		display: inline-block;
		margin: 0px 2px;
	}


	.page_1 {
		text-align: center;

		margin-top: 25px;
		margin-bottom: 60px;
	}

	.page_1 a {
		padding: 5px 10px;

		display: inline-block;
		font-size: 14px;
		text-align: center;
		background: #d7d7d7;
		margin: 0px 5px;
		border: 1px solid #d6d6d6;
		border-radius: 4px;
		color: #fff;
	}


	.page_1 a:hover {

		color: #fff;
		border: 1px solid #0b6db8;
		background: #0b6db8 !important;
	}

	.page_1 .on {

		color: #fff;
		border: 1px solid #0b6db8;
		background: #0b6db8;
	}

	.index_warp .group .item .img {
		margin: 1% 3%;
		text-align: center;
		width: 94% !important;
	}

	@media screen and (max-width:1200px) {
		.index_warp .group .item {
			width: 48%;
			margin: 0px auto;
			margin-bottom: 20px;
		}

		.index_warp .group .item:nth-child(2n) {
			float: right;
			width: 48%;
			margin: 0px auto;
			margin-bottom: 20px;
		}

		.index_warp .group .item .show_boxs {
			display: none !important;
			width: 0px;
			height: 0px;
			overflow: hidden;
		}

		.index_warp .ntnt {
			font-size: 20px;
		}

		.index_warp .warp_items {
			margin-bottom: 20px;
		}

		.index_banner {
			height: 300px !important;
		}
	}
</style>
